// Format a byte count as a human-readable string (B/KB/MB/GB/TB).
// Uses the SI 1024-based scale to match how every storage UI on the
// market displays usage; flagging exact values (e.g. "1024 B") would
// confuse operators reading the storage page.

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export function formatBytes(bytes: number, fractionDigits = 1): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes === 0) return '0 B';
  let i = 0;
  let value = bytes;
  while (value >= 1024 && i < UNITS.length - 1) {
    value /= 1024;
    i += 1;
  }
  // Whole-byte values stay integer (no `.0` noise on counts under 1KB).
  if (i === 0) return `${value.toFixed(0)} B`;
  // The while-loop guarantees i is in range, but TS infers `string | undefined`
  // from index access. Coerce — UNITS is a tuple so any in-range read is safe.
  const unit = UNITS[i] ?? 'B';
  return `${value.toFixed(fractionDigits)} ${unit}`;
}
